import { render, staticRenderFns } from "./AnnouncementListActions.vue?vue&type=template&id=b1d9004c"
import script from "./AnnouncementListActions.vue?vue&type=script&lang=js"
export * from "./AnnouncementListActions.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementListActions.vue?vue&type=style&index=0&id=b1d9004c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports